import React from 'react';

import { AppleIconProps } from '../../types';

/**
 * Apple 图标组件
 * 用于显示 Apple 系统的下载图标
 */
const AppleIcon: React.FC<AppleIconProps> = ({
  width = 20,
  height = 20,
  color = '#000000',
  className,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 81 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M65.7069 55.4714C65.6281 55.7105 64.397 60.0046 61.3721 64.4202C58.7541 68.2291 56.0469 72.0688 51.7713 72.1362C47.5666 72.2101 46.2211 69.6274 41.4205 69.6274C36.626 69.6274 35.1187 72.0688 31.145 72.2101C27.0371 72.3783 23.8761 68.0495 21.2482 64.2592C15.8774 56.4947 11.742 42.2564 17.2882 32.7144C20.017 27.9402 24.9219 24.9055 30.2631 24.8226C34.2881 24.7465 38.1177 27.5492 40.5624 27.5492C43.074 27.5492 47.7066 24.1579 52.594 24.6653C54.6403 24.7525 60.364 25.5207 64.0518 30.8657C63.7617 31.0631 57.2032 34.9334 57.2763 42.8105C57.3749 52.3201 65.6181 55.4389 65.7069 55.4714ZM49.3958 19.5714C51.5997 16.883 53.0479 13.1876 52.6669 9.51758C49.5201 9.641 45.6862 11.6074 43.4076 14.2798C41.3929 16.6114 39.6172 20.3644 40.1124 23.9918C43.6088 24.2041 47.2037 22.1608 49.3958 19.5714Z"
        fill={color}
      />
    </svg>
  );
};

export default AppleIcon;
